// src/pages/admin/AdminHiringRequisitions.jsx
// ============================================================
// Wrapper component redirecting to the Hiring Requisitions tab
// inside the main Admin Recruitment module (AdminAssignedCandidates).
// ============================================================

import React from "react";
import AdminAssignedCandidates from "./AdminAssignedCandidates";

export default function AdminHiringRequisitions() {
  return <AdminAssignedCandidates defaultTab="requisitions" />;
}
